import { render, staticRenderFns } from "./PoveznicaData.vue?vue&type=template&id=ad2260e0&scoped=true&"
import script from "./PoveznicaData.vue?vue&type=script&lang=js&"
export * from "./PoveznicaData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2260e0",
  null
  
)

export default component.exports